import React from 'react';
import PropTypes from 'prop-types';
import clone from 'clone';
import canAutoplay from 'can-autoplay';
import {VelocityTransitionGroup} from 'velocity-react';

import {AppFlags} from '../../../app/app-types';
import {connectAppEnv} from '../../../app/app-env';
import {withUILevel} from '../../../lib/react/oe-higher-order-components';
import {oeInterfaceManager} from '../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../react-oe/oe-interface-adapter';
import {OEVHLayouter} from '../../../lib/components/oe-vh-layouter';
import OEToolbox from '../../../lib/tools/oe-toolbox';
import OEAnimateHelper from '../../../lib/animation/oe-animate-helper';
import OENotification from '../../../lib/notification/oe-notification';
import ElementEventListenerAdapter from '../../../lib/components/element-event-listener-adapter';
import OEIconCodes from '../../../lib/oe-icon-codes';
import retardUpdate from '../../../lib/react/update-retarder';
import {OEMediaCenterItemTypes, OEMediaCenterPropTypes, OEMediaCenterConfigFactory, OEMediaCenterAutoplayMode, OEMediaCenterModeBottomBarLayoutType, OEMediaCenterMode} from './oe-media-center-model';
import OEMediaCenterPlayModeControls from './components/oe-media-center-play-mode-controls';
import OEMediaCenterRightBar from './components/oe-media-center-right-bar';
import OEMediaCenterBottomBar from './components/oe-media-center-bottom-bar';
import {OEAnimationControlAdapterStd, OEAnimationControlAdapterMediaViewer} from '../../animation-control/oe-animation-adapter';
import OEAnimationControl from '../../animation-control/oe-animation-control';
import {OEMediaViewerContentType, OEMediaViewerContentSizeMode, OEMediaViewerContent, OEMediaViewerDataSourceIntrinsic} from '../../media-viewer/oe-media-viewer-model';
import OEMediaViewerController from '../../media-viewer/oe-media-viewer-controller';
import OEMediaCenterMediaViewerDataSource from './oe-media-center-media-viewer-data-source';
import {OEPresentationFlags, OEPresentationPlayableFlags, OEPresentationDefaultAnimatableState} from '../presentation/oe-presentation-model';
import {OEModal} from '../../modals/oe-modal';
import {OEManualViewLinks} from '../../views/manual-view/oe-manual-view-model';
import {OEDefaultConfigFactory} from '../../oe-default-configs';

export class OEMediaCenter extends React.PureComponent {

    constructor(props) {
        super(props);

        this.props.appComponent.mediaCenter = this;

        this.mounted = false;
        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        // next three fields configuring play mode control btns & presentation slide preview should be considered as constant
        this.controlOnlyPreviewSlides = true;
        this.showOnlyPreviewSlides = true;
        this.wrap = false;

        //
        this.uiVisible = false;
        this.playMode = false;
        this.directPlay = {enabled: false, trapped: false};

        this.blurring = false;
        this.uiBlocking = false;
        this.appliedUIBlocking = false;

        this.mediaViewerVisible = false;

        this.rightBarSize = {w: 0, h: 0};

        this.layout = {rightBarFullHeight: true};

        this.edgeOffsets = {top: 0, right: 0, bottom: 0, left: 0};
        this.maxEdgeOffsets = {top: 0, right: 0, bottom: 0, left: 0};
        this.bottomBarEdgeOffsets = {top: 0, right: 0, bottom: 0, left: 0};

        this.rightBar = {edgeOffsets: this.determineRightBarEdgeOffsets(false)};
        this.centralView = {showAnimationControl: false, noForwardBackwardButtons: false, noStopButton: false};
        this.bottomBar = {edgeOffsets: this.determineBottomBarEdgeOffsets(false)};

        this.animationControl = {enabled: false, adapter: null};

        this.categories = [];
        this.items = [];
        this.mediaViewerDataSource = new OEMediaCenterMediaViewerDataSource();
        this.mediaViewerContentIndex = {index: 0, applied: {animated: false, progress: 0}};
        this.mediaViewerAdapter = new OEAnimationControlAdapterMediaViewer();

        this.actualItemId = {item: -1, subItem: -1};
        this.actualItem = null;

        this.itemType = OEMediaCenterItemTypes.none;
        this.presID = -1;
        this.progress = 0;

        this.playEnabled = true;

        this.bottomBarModeLayoutType = OEMediaCenterModeBottomBarLayoutType.std;
        this.bottomBarConfig = {...this.props.config};

        this.state = {
            uiVisible:                  this.uiVisible,
            uiEnabled:                  false,
            enabled:                    false,
            playMode:                   this.playMode,
            directPlay:                 clone(this.directPlay),
            blurring:                   false,
            mediaViewerVisible:         this.mediaViewerVisible,
            layout:                     clone(this.layout),
            edgeOffsets:                this.edgeOffsets,
            maxEdgeOffsets:             this.maxEdgeOffsets,
            rightBar:                   clone(this.rightBar),
            centralView:                clone(this.centralView),
            bottomBar:                  clone(this.bottomBar),
            animationControl:           Object.assign({}, this.animationControl),
            userHidePlayModeControls:   false,
            hidePlayModeControls:       false,
            actualItem:                 null,
            itemType:                   this.itemType,
            presID:                     this.presID,
            progress:                   this.progress,
            playEnabled:                this.playEnabled,
            showMediaDataSource:        null,
            applyingAutoplay:           false,
            bottomBarModeLayoutType:    this.bottomBarModeLayoutType,
            bottomBarConfig:            clone(this.bottomBarConfig)
        };

        this.onKeyDown = this.onKeyDown.bind(this);
 
        this.onLanguageChanged = this.onLanguageChanged.bind(this);
        this.onUIControllerStateChanged = this.onUIControllerStateChanged.bind(this);
        this.onEnabledStateChanged = this.onEnabledStateChanged.bind(this);
        this.onActualMediaCenterItemChanged = this.onActualMediaCenterItemChanged.bind(this);
        this.onActualMediaCenterSubItemChanged = this.onActualMediaCenterSubItemChanged.bind(this);
        this.onMediaCenterAnimationModeChanged = this.onMediaCenterAnimationModeChanged.bind(this);
        this.onMediaCenterProgressChanged = this.onMediaCenterProgressChanged.bind(this);
        this.onMediaCenterItemSliderConfigChanged = this.onMediaCenterItemSliderConfigChanged.bind(this);
        this.onMediaCenterShortCut = this.onMediaCenterShortCut.bind(this);
        this.onActivePresentationSlideChanged = this.onActivePresentationSlideChanged.bind(this);
        this.onPresentationDataChanged = this.onPresentationDataChanged.bind(this);
        this.onPresentationAnimatableStateChanged = this.onPresentationAnimatableStateChanged.bind(this);
        this.onPresentationSlideAttributesChanged = this.onPresentationSlideAttributesChanged.bind(this);

        this.onBottomBarModeLayoutTypeChanged = this.onBottomBarModeLayoutTypeChanged.bind(this);
        this.onRightBarSizeChanged = this.onRightBarSizeChanged.bind(this);
        this.onRightBarEdgeOffsetsChanged = this.onRightBarEdgeOffsetsChanged.bind(this);
        this.onBottomBarEdgeOffsetsChanged = this.onBottomBarEdgeOffsetsChanged.bind(this);

        this.onMediaViewerRef = this.onMediaViewerRef.bind(this);
        this.onRightBarRef = this.onRightBarRef.bind(this);
        this.onBottomBarRef = this.onBottomBarRef.bind(this);

        this.onResetHidePlayModeControlsCycleEvent = this.onResetHidePlayModeControlsCycleEvent.bind(this);
        
        this.onItemCollectionSelected = this.onItemCollectionSelected.bind(this);

        this.onProgressSliderChanged = this.onProgressSliderChanged.bind(this);
        this.onAnimationControlPlay = this.onAnimationControlPlay.bind(this);
        this.onAnimationControlPause = this.onAnimationControlPause.bind(this);
        this.onAnimationControlStop = this.onAnimationControlStop.bind(this);
        this.onPlayModeAnimationControlPlay = this.onPlayModeAnimationControlPlay.bind(this);
        this.onPlayModeAnimationControlPause = this.onPlayModeAnimationControlPause.bind(this);
        this.onPlayModeAnimationControlStop = this.onPlayModeAnimationControlStop.bind(this);
        this.onPlayModeAnimationControlBackward = this.onPlayModeAnimationControlBackward.bind(this);
        this.onPlayModeAnimationControlForward = this.onPlayModeAnimationControlForward.bind(this);

        this.onMediaItemChanged = this.onMediaItemChanged.bind(this);
        this.onMediaViewerProgressChanged = this.onMediaViewerProgressChanged.bind(this);
        this.shouldChangePrev = this.shouldChangePrev.bind(this);
        this.shouldChangeNext = this.shouldChangeNext.bind(this);
        this.onGoToItem = this.onGoToItem.bind(this);
        this.onShowMedia = this.onShowMedia.bind(this);
        this.onCloseBtnPressed = this.onCloseBtnPressed.bind(this);
    }

    setOpen(open)   {
        if(!this.oe.isReady()) return this.uiVisible;
        open = !!open;
        if(open == this.uiVisible)  return this.uiVisible;
        let result = this.oe.sharedInterface.getUIControllerMediaCenter().setUIVisible(open);
        if(result === this.uiVisible)   return this.uiVisible;
        // we do not want for the async update via uiControllerStateChanged notification here
        this.updateUIState();
        this.updateForPlayMode();
        return this.uiVisible;
    }

    setActiveCategory(index) {
        if(!this.oe.isReady() || typeof(index) !== 'number')  return 0;
        return this.oe.sharedInterface.getUIControllerMediaCenter().setActualCategory(index);
    }

    setActiveMediaCenterItem(identifier)  {
        if(!this.oe.isReady() || (typeof(identifier) !== 'string' && typeof(identifier) !== 'number'))  return 0;

        if(typeof(identifier) === 'string') {
            return this.oe.sharedInterface.getUIControllerMediaCenter().setActualMediaItemResourceID(identifier);
        } else {
            return this.oe.sharedInterface.getUIControllerMediaCenter().setActualMediaItemID(identifier);
        }
    }

    play(direct) {
        retardUpdate(this, () => {
            if(['boolean', 'object'].includes(typeof(direct)))    this.setDirectPlay(direct);

            if(this.playEnabled)    {
                if(this.adapter)    this.adapter.play();
            } else {
                if(this.adapter)    this.adapter.pause();
                if(this.oe.isReady() && this.itemType === OEMediaCenterItemTypes.presentation)   this.oe.sharedInterface.getUIControllerPresentation().apply(true);
            }

            this.setPlayMode(true);
            this.resetHidePlayModeControlsCycle();
        });
    }

    pause() {
        if(this.adapter)    this.adapter.pause();
    }

    stop()    {
        if(this.adapter) this.adapter.pause();

        if(!this.directPlay.enabled)    {
            this.setPlayMode(false);
        }
    }

    setDirectPlay(enabled, trapped) {
        if(typeof(enabled) !== 'object' || !enabled) {
            this.setDirectPlay({enabled: !!enabled, trapped: !!trapped});
            return;
        }

        let directPlay = enabled;
        directPlay = {enabled: !!directPlay.enabled, trapped: !!directPlay.trapped};

        if(OEToolbox.shallowEqual(this.directPlay, directPlay)) return;
        this.directPlay = directPlay;
        retardUpdate(this, () => {
            this.setState({directPlay: clone(this.directPlay)});
            this.onDirectPlayChanged();
        });
    }

    getDirectPlay() {
        return {...this.directPlay};
    }

    setPlayMode(play)   {
        if(this.playMode === play || (!this.playModeAvailable && play)) return;
        this.playMode = play;

        retardUpdate(this, () => {
            this.setState({playMode: this.playMode});
            this.onPlayModeChanged();
        });
    }

    clearHidePlayModeControlsTimer()    {
        if(!this.hidePlayModeControlsTimer) return;
        clearTimeout(this.hidePlayModeControlsTimer); this.hidePlayModeControlsTimer = null;
    }

    resheduleHidePlayModeControlsTimer()  {
        this.clearHidePlayModeControlsTimer();
        this.hidePlayModeControlsTimer = setTimeout(() => { this.setState({hidePlayModeControls: true}); }, 2000);
    }

    resetHidePlayModeControlsCycle(props)    {
        if(this.mounted === false) return;
        this.setState({hidePlayModeControls: false});

        props = props || this.props;
        if(!props.config.playModeControlsFadeOut)   {
            this.clearHidePlayModeControlsTimer();
            return;
        }

        this.resheduleHidePlayModeControlsTimer();
    }

    shouldAutoplay(autoplay)    {
        if(typeof(autoplay) !== 'number')   autoplay = this.props.config.autoplay;
        return this.oe.isReady() && OEMediaCenterAutoplayMode.isPlay(autoplay) && this.uiVisible && this.actualItem;
    }

    applyAutoplay_(autoplay) {
        if(typeof(autoplay) !== 'number')   autoplay = this.props.config.autoplay;

        if(!this.shouldAutoplay(autoplay))  {
            this.setDirectPlay(false);
            this.setPlayMode(false);
            this.pause();
            return Promise.resolve();
        }

        let si = this.oe.sharedInterface;

        let hasAudio = false;
        if(this.actualItem.type === OEMediaCenterItemTypes.presentation)    {
            hasAudio = si.getUIControllerPresentation().hasAudioTrackID(this.actualItem.index);
        } else if(this.actualItem.type === OEMediaCenterItemTypes.animation)    {
            hasAudio = si.getUIControllerAnimation().hasAudioTrackID(this.actualItem.index);
        }
        let isVideo = this.actualItem.type === OEMediaCenterItemTypes.video;

        //
        if(!hasAudio && !isVideo)   {
            this.play({enabled: OEMediaCenterAutoplayMode.isDirectPlay(autoplay), trapped: autoplay === OEMediaCenterAutoplayMode.directPlayTrap});
            return Promise.resolve();
        }

        //
        if(OEMediaCenterAutoplayMode.isDirectPlay(autoplay)) {
            this.setDirectPlay({enabled: true, trapped: autoplay === OEMediaCenterAutoplayMode.directPlayTrap});
        }

        return new Promise((resolve, reject) => {
            let fn = isVideo ? canAutoplay.video : canAutoplay.audio;

            fn().then(res => {

                if(!res.result) {
                    if(!this._canNotAutoplayMessage)    console.log('Can not autoplay due to autoplay policy');
                    this._canNotAutoplayMessage = true;
                    return;
                }

                this.play({enabled: OEMediaCenterAutoplayMode.isDirectPlay(autoplay), trapped: autoplay === OEMediaCenterAutoplayMode.directPlayTrap});

            }).finally(() => {
                resolve();
            });
        });
    }

    applyAutoplay(autoplay, save = true, update = true) {
        if(typeof(autoplay) !== 'number')   autoplay = this.props.config.autoplay;

        //
        if(!save)   {
            let result;
            
            retardUpdate(this, () => {
                this.setState({applyingAutoplay: true});

                if(update && this.oe.isReady())  {
                    this.updateUIState();
                    this.updateEnabledState();
                    this.updateActualMediaCenterItem();
                }

                result = this.applyAutoplay_(autoplay).finally(() => {
                    this.setState({applyingAutoplay: false});
                });
            });

            return result;
        }

        //
        // we make two calls to applyAutoplay here, the first one is to set the control state completely at start to prevent that elements like the play button are becomming visibly for a moment
        // the second call is deferred after all other controllers have finished their onConnect call and is necessary, since some controllers may overwrite the animation mode, here at least in OEPresentationController::onActivePresentationChanged this occurs
        if(!this.shouldAutoplay(autoplay))   return this.applyAutoplay_(autoplay);

        retardUpdate(this, () => {
            this.setState({applyingAutoplay: true});
            if(update)  {
                this.updateUIState();
                this.updateEnabledState();
                this.updateActualMediaCenterItem();
            }
            this.applyAutoplay_(autoplay);
        });

        return new Promise((resolve, reject) => {
            window.requestAnimationFrame(() => {
                retardUpdate(this, () => {
                    this.applyAutoplay_(autoplay).finally(() => {
                        this.setState({applyingAutoplay: false});
                        resolve();
                    });
                });
            });
        });
    }

    componentDidMount()    {
        this.mounted = true;

        this.resetHidePlayModeControlsCycle();

        retardUpdate(this, () => {
            this.updateBlur();
        });

        window.addEventListener('keydown', this.onKeyDown);
    }

    componentWillUnmount()    {
        this.mounted = false;

        this.clearHidePlayModeControlsTimer();

        retardUpdate(this, () => {
            this.updateBlur();
        });

        window.removeEventListener('keydown', this.onKeyDown);
    }

    componentWillReceiveProps(nextProps) {
        if(!OEToolbox.shallowEqual(nextProps.config, this.props.config, true))   {

            if(!nextProps.config.playModeControlsFadeOut && nextProps.config.playModeControlsFadeOut !== this.props.config.playModeControlsFadeOut) {
                this.resetHidePlayModeControlsCycle(nextProps);
            }

            this.updateControls(nextProps);
        }

        if(nextProps.config.mode !== this.props.config.mode)   {
            this.updateEdgeOffsets(false, nextProps);
        }
    }

    onConnect()  {
        this.applyUIBlocking();

        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.onLanguageChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.mediaCenterEnabledStateChanged, this.onEnabledStateChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.actualMediaCenterItemChanged, this.onActualMediaCenterItemChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.actualMediaCenterSubItemChanged, this.onActualMediaCenterSubItemChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.mediaCenterAnimationModeChanged, this.onMediaCenterAnimationModeChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.mediaCenterProgressChanged, this.onMediaCenterProgressChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.mediaCenterItemSliderConfigChanged, this.onMediaCenterItemSliderConfigChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.mediaCenterShortCut, this.onMediaCenterShortCut);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.activePresentationSlideChanged, this.onActivePresentationSlideChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.presentationDataChanged, this.onPresentationDataChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.presentationAnimatableStateChanged, this.onPresentationAnimatableStateChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.presentationSlideAttributesChanged, this.onPresentationSlideAttributesChanged);
    }

    onRelease()  {
        this.applyUIBlocking(false);

        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.onLanguageChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.mediaCenterEnabledStateChanged, this.onEnabledStateChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.actualMediaCenterItemChanged, this.onActualMediaCenterItemChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.actualMediaCenterSubItemChanged, this.onActualMediaCenterSubItemChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.mediaCenterAnimationModeChanged, this.onMediaCenterAnimationModeChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.mediaCenterProgressChanged, this.onMediaCenterProgressChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.mediaCenterItemSliderConfigChanged, this.onMediaCenterItemSliderConfigChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.mediaCenterShortCut, this.onMediaCenterShortCut);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.activePresentationSlideChanged, this.onActivePresentationSlideChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.presentationDataChanged, this.onPresentationDataChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.presentationAnimatableStateChanged, this.onPresentationAnimatableStateChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.presentationSlideAttributesChanged, this.onPresentationSlideAttributesChanged);
    }

    onKeyDown(event)    {
        if(!this.props.devFeatures || event.key != 'c' || !this.playMode) return;
        this.setState({userHidePlayModeControls: !this.state.userHidePlayModeControls});
    }

    updateForPlayMode() {
        this.updateControls();

        if(this.playMode && this.oe.sharedInterface.getUIControllerMediaCenter().getUIVisible() && !this.oe.sharedInterface.getUIControllerPresentation().getUIVisible() && this.props.appComponent && this.props.appComponent.uiLayer)    {
            this.props.appComponent.uiLayer.closeAllPopovers();
            if(this.props.config.hideLeftSlideInInPlayMode) {
                this.props.appComponent.uiLayer.showLeftSlideIn(false, true);
            }
        }
    }

    onPlayModeChanged() {
        retardUpdate(this, () => {
            if(!this.playMode)  this.setDirectPlay(false);
            this.updateForPlayMode();
            this.setState({userHidePlayModeControls: false});
            this.resetHidePlayModeControlsCycle();
        });
    }

    onDirectPlayChanged()   {
        this.updateControls();
        this.updateEdgeOffsets(false);

        if(this.props.appComponent && this.props.appComponent.uiLayer) {
            this.props.appComponent.uiLayer.notificationCenter.post(OENotification.mediaCenterDirectPlayChanged, {...this.directPlay});
        }
    }

    onBlurringChanged(props, released) {
        props = props || this.props;
        if(props.appComponent && props.appComponent.blurCoreLayer)    props.appComponent.blurCoreLayer.setBlur(this.blurring);

        this.updateUIBlocking();

        retardUpdate(this, () => {
            this.setState({blurring: this.blurring});
        });
    }

    shouldBlur(props)   {
        if(!this.mounted || !this.uiVisible)    return false;
        if(this.mediaViewerVisible) return true;
        if(this.playMode || !this.centralView.showAnimationControl) return false;
        return true;
    }

    updateBlur(props, override, released)   {
        let shouldBlur = typeof(override) === 'boolean' ? override : this.shouldBlur(props);
        if(shouldBlur == this.blurring) return;
        this.blurring = shouldBlur;
        this.onBlurringChanged(props, released);
    }

    updateUIBlocking()  {
        if(this.uiBlocking == this.blurring)    return;
        this.uiBlocking = this.blurring;
        this.applyUIBlocking();
    }

    applyUIBlocking(uiBlocking) {
        if(!this.oe.isReady())  return;
        uiBlocking = uiBlocking === undefined ? this.uiBlocking : !!uiBlocking;
        if(this.appliedUIBlocking == uiBlocking)    return;
        this.oe.sharedInterface.getUIControllerMediaCenter().setManUIBlocking(uiBlocking);
        this.appliedUIBlocking = uiBlocking;
    }

    updateLayout()  {
        let layout = {rightBarFullHeight: this.rightBarSize.w > 200};

        if(OEToolbox.shallowEqual(this.layout, layout)) return;
        this.layout = layout;
        this.setState({layout: clone(this.layout)});

        this.updateRightBarEdgeOffsets(false);
        this.updateBottomBarEdgeOffsets(false);
    }
    
    updateEdgeOffsets(animated = true, props) {
        props = props || this.props;

        let rightBarEdgeOffsets = this.rightBarRef ? this.rightBarRef.getEdgeOffsets() : {right: 0};
        let _bottomBarEdgeOffsets = this.bottomBarRef ? this.bottomBarRef.getEdgeOffsets() : {bottom: 0};
        let bottomBarMaxEdgeOffsets = this.bottomBarRef ? this.bottomBarRef.getMaxEdgeOffsets() : {bottom: 0};

        //
        let edgeOffsets = {
            top: 0,
            right: rightBarEdgeOffsets.right,
            left: 0,
            bottom: _bottomBarEdgeOffsets.bottom,
            animate: animated ? OEAnimateHelper.merge(_bottomBarEdgeOffsets.animate, rightBarEdgeOffsets.animate) : false
        };

        //
        let maxEdgeOffsets = {
            top: 0,
            right: !this.directPlay.enabled ? rightBarEdgeOffsets.right : 0,
            left: 0,
            bottom: bottomBarMaxEdgeOffsets.bottom,
            animate: animated ? OEAnimateHelper.merge(bottomBarMaxEdgeOffsets.animate, rightBarEdgeOffsets.animate) : false
        };

        //
        let bottomBarModeHLayout = props.config.mode === OEMediaCenterMode.bottomBar && this.bottomBarModeLayoutType === OEMediaCenterModeBottomBarLayoutType.horizontal;
        let bottomBarModeVLayout = props.config.mode === OEMediaCenterMode.bottomBar && this.bottomBarModeLayoutType === OEMediaCenterModeBottomBarLayoutType.vertical;

        let bottomBarEdgeOffsets = {
            top: 0,
            right: bottomBarModeVLayout ? rightBarEdgeOffsets.right : 0,
            left: 0,
            bottom: bottomBarModeHLayout ? _bottomBarEdgeOffsets.bottom : 0,
            animate: animated ? {right: bottomBarModeVLayout ? OEAnimateHelper.animateRight(rightBarEdgeOffsets.animate) : true, bottom: bottomBarModeHLayout ? OEAnimateHelper.animateBottom(_bottomBarEdgeOffsets.animate) : true} : false
        };

        //
        let newState = {};

        if(!OEAnimateHelper.offsetEqual(edgeOffsets, this.edgeOffsets)) {
            this.edgeOffsets = edgeOffsets;
            newState.edgeOffsets = this.edgeOffsets;
            if(props.onEdgeOffsetsChanged)  props.onEdgeOffsetsChanged(this, edgeOffsets);
            this.updateRightBarEdgeOffsets(animated);
            this.updateBottomBarEdgeOffsets(animated);
        }

        //
        if(!OEAnimateHelper.offsetEqual(maxEdgeOffsets, this.maxEdgeOffsets)) {
            this.maxEdgeOffsets = maxEdgeOffsets;
            newState.maxEdgeOffsets = this.maxEdgeOffsets;
        }

        //
        if(!OEAnimateHelper.offsetEqual(bottomBarEdgeOffsets, this.bottomBarEdgeOffsets)) {
            this.bottomBarEdgeOffsets = bottomBarEdgeOffsets;
            if(props.onBottomBarEdgeOffsetsChanged)  props.onBottomBarEdgeOffsetsChanged(this, bottomBarEdgeOffsets);
        }

        //
        if(OEToolbox.shallowEqual({}, newState, true))  return;

        this.setState(newState);
    }

    determineRightBarEdgeOffsets(animated = true) {
        return {bottom: this.layout.rightBarFullHeight ? 0 : this.edgeOffsets.bottom, animate: animated && OEAnimateHelper.animateBottom(this.edgeOffsets.animate)};
    }

    determineBottomBarEdgeOffsets(animated = true) {
        return {right: this.layout.rightBarFullHeight ? this.edgeOffsets.right : 0, animate: animated && OEAnimateHelper.animateRight(this.edgeOffsets.animate)}
    }

    updateRightBarEdgeOffsets(animated = true) {
        let edgeOffsets = this.determineRightBarEdgeOffsets(animated);
        if(OEAnimateHelper.offsetEqual(edgeOffsets, this.rightBar.edgeOffsets)) return;
        this.rightBar.edgeOffsets = edgeOffsets;
        this.setState({rightBar: clone(this.rightBar)});
    }

    updateBottomBarEdgeOffsets(animated = true) {
        let edgeOffsets = this.determineBottomBarEdgeOffsets(animated);
        if(OEAnimateHelper.offsetEqual(edgeOffsets, this.bottomBar.edgeOffsets)) return;
        this.bottomBar.edgeOffsets = edgeOffsets;
        this.setState({bottomBar: clone(this.bottomBar)});
    }

    updateLanguage()   {}

    updateUIState()   {
        let controller = this.oe.sharedInterface.getUIControllerMediaCenter();
        let uiVisible = controller.getUIVisible();
        let uiVisibleChanged = this.uiVisible !== uiVisible;

        this.uiVisible = uiVisible;

        retardUpdate(this, () => {
            this.setState({
                uiVisible: this.uiVisible,
                uiEnabled: controller.getUIEnabled()
            });
            this.updateBlur();
        });

        controller.setEnabled(this.uiVisible);

        if(uiVisibleChanged)    {
            if(controller.getAnimationMode() !== this.oe.Module.AnimationMode.play)    this.setPlayMode(false);
        }
    }

    updateEnabledState(enabled)    {
        let controller = this.oe.sharedInterface.getUIControllerMediaCenter();
        let uiVisible = controller.getUIVisible();
        if(uiVisible && !enabled)   {
            controller.setEnabled(uiVisible);
            enabled = controller.getEnabled();  // continue with updated value here!
        }
        this.setState({enabled: typeof(enabled) === 'boolean' ? enabled : controller.getEnabled()});
    }

    updateCategories()  {
        this.categories = this.oe.sharedInterface.getUIControllerMediaCenter().getCategories();
    }

    updateItems()  {
        this.items = this.oe.sharedInterface.getUIControllerMediaCenter().getMediaItemDataList();
    }

    findItem(itemId)  {
        if(!itemId || !itemId.item || itemId.item < 0) return;
        let item = this.items.find((item) => item.id == itemId.item);
        if(!item || !itemId.subItem || itemId.subItem < 0) return item;
        return item.subItems.find((item) => item.id == itemId.subItem);
    }

    updateActualMediaCenterItem()   {
        let controller = this.oe.sharedInterface.getUIControllerMediaCenter();
        this.actualItemId = {item: controller.getActualMediaItemID(), subItem: -1};
        this.updateActualMediaCenterSubItem();
    }

    updateActualMediaCenterSubItem()    {
        let controller = this.oe.sharedInterface.getUIControllerMediaCenter();
        this.actualItemId.subItem = controller.getActualMediaSubItemID();
        this.actualItem = controller.mediaItemID(this.actualItemId.item, this.actualItemId.subItem);
        if(this.actualItem) this.actualItem.type = this.actualItem.type.value;
        this.updateForItem();
    }

    updateForItem(props)    {
        if(!this.oe.isReady())  return;

        props = props || this.props;
        let controller = this.oe.sharedInterface.getUIControllerMediaCenter();
        let mediaItem = this.actualItem;
        let mediaItemId = this.actualItemId;

        this.itemType = OEMediaCenterItemTypes.none;
        this.presID = -1;

        if(mediaItem)   {
            this.itemType = mediaItem.type;
            this.progress = controller.getProgress();

            if(this.mediaViewerDataSource.indexForItem(mediaItemId) >= 0)   {

                this.setMediaViewerContent(mediaItemId, this.progress);

            } else if(this.itemType === OEMediaCenterItemTypes.presentation) {

                this.presID = mediaItem.index;
            }
        }

        retardUpdate(this, () => {
            this.setState({
                actualItem: this.actualItem,
                itemType: this.itemType,
                presID: this.presID,
                progress: this.progress
            });

            this.updateAdapter(props);
        });
    }

    updateAdapter(props)    {
        if(!this.oe.isReady())  return;

        props = props || this.props;
        let mediaItem = this.actualItem;
        let mediaItemId = this.actualItemId;

        if(this.adapter)    {
            this.adapter.unregisterControl(this);
            if(this.adapter !== this.mediaViewerAdapter)  this.adapter.clearBinding();
            this.adapter = null;
        }

        if(this.mediaViewerDataSource.indexForItem(mediaItemId) >= 0)   {
            this.adapter = this.mediaViewerAdapter;
        } else if(this.itemType === OEMediaCenterItemTypes.animation) {
            this.adapter = new OEAnimationControlAdapterStd();
            this.adapter.disabledWhenStop = false;
            this.adapter.setBinding(this.oe, OEAnimationControlAdapterStd.Binding.animation, mediaItem.index);
        } else if(this.itemType === OEMediaCenterItemTypes.presentation) {
            this.adapter = new OEAnimationControlAdapterStd();
            this.adapter.disabledWhenStop = false;
            this.adapter.setBinding(this.oe, OEAnimationControlAdapterStd.Binding.presentation, mediaItem.index);
        }

        if(this.adapter)    this.adapter.registerControl(this);

        this.updateControls(props);
    }

    updateControls(props)   {
        if(!this.oe.isReady())  {
            retardUpdate(this, () => {
                this.updateBlur(props);
            });
            return;
        }

        props = props || this.props;
        let config = props.config;
        let mediaItem = this.actualItem;
        let mediaItemId = this.actualItemId;

        this.playEnabled = true;
        this.playModeAvailable = true;
        this.mediaViewerVisible = false;
        this.centralView = {showAnimationControl: false, noForwardBackwardButtons: false, noStopButton: false};
        this.animationControl = {enabled: false, adapter: this.adapter};
        this.bottomBarConfig = {...config};

        if(!mediaItem)   {

            this.playModeAvailable = false;

        } else {

            if(this.mediaViewerDataSource.indexForItem(mediaItemId) >= 0)   {
                this.mediaViewerVisible = true;
                this.animationControl.enabled = true;
            } else if(this.itemType === OEMediaCenterItemTypes.animation) {
                this.centralView.showAnimationControl = config.bigPlayBtn && mediaItem.enableAnimationControls;
                this.centralView.noForwardBackwardButtons = true;
                this.animationControl.enabled = mediaItem.enableAnimationControls;
            } else if(this.itemType === OEMediaCenterItemTypes.presentation) {
                let presController = this.oe.sharedInterface.getUIControllerPresentation();

                //
                let presFlags = presController.getPresentationFlagsID(this.presID);

                let presPlayableFlags = presController.getPresentationPlayableFlagsID(this.presID);
                if(typeof(presPlayableFlags) !== 'number')  presPlayableFlags = config.presPlayableFlags;

                let animatableState = presController.getPresentationAnimatableStateID(this.presID) || OEPresentationDefaultAnimatableState;

                let slideID = presController.getActivePresentationSlideID(this.presID);
                if(slideID < 0 && presController.getNumSlidesID(this.presID))   slideID = presController.getSlideID(presController.getPresentationIndexForID(this.presID), 0);      // if no slide is active the first slide is relevant for hasSlideAnimatableAttributeID and playEnabled determination
                let hasSlideAnimatableAttribute = presController.hasSlideAnimatableAttributeID(this.presID, slideID);

                //
                this.centralView.showAnimationControl = config.bigPlayBtn && (animatableState.canAnimate || this.directPlay.enabled); // no big play button for play mode if not animatable
                this.centralView.noForwardBackwardButtons = animatableState.slideCount == 0 || !!(presFlags & OEPresentationFlags.noBackForth);
                this.centralView.noStopButton = this.directPlay.enabled && this.directPlay.trapped;

                this.playModeAvailable = animatableState.canAnimate || this.directPlay.enabled;

                this.animationControl.enabled = animatableState.canAnimate || this.directPlay.enabled;

                this.playEnabled = OEPresentationPlayableFlags.isPlayable(typeof(presPlayableFlags) === 'number' ? presPlayableFlags : OEPresentationPlayableFlags.all, animatableState, hasSlideAnimatableAttribute);

                this.bottomBarConfig.noPresPreview = presFlags & OEPresentationFlags.noPreviewSlides;
            }

            if(this.itemType !== OEMediaCenterItemTypes.presentation && this.itemType !== OEMediaCenterItemTypes.animation && !this.adapter)   {
                this.playModeAvailable = false;
            }

            this.resetHidePlayModeControlsCycle(props);
        }

        retardUpdate(this, () => {
            this.setState({
                centralView:            clone(this.centralView),
                animationControl:       Object.assign({}, this.animationControl),
                mediaViewerVisible:     this.mediaViewerVisible,
                playEnabled:            this.playEnabled,
                bottomBarConfig:        clone(this.bottomBarConfig)
            });

            if(!this.playModeAvailable) this.setPlayMode(false);

            if(!this.playEnabled && this.adapter)    this.adapter.pause();

            this.oe.sharedInterface.getUIControllerMediaCenter().setPlayEnabled(this.playEnabled);

            this.updateBlur(props);
        });
    }

    updateForProgress(progress) {
        this.progress = progress;
        this.setState({progress: this.progress});
    }

    updateMediaViewerDataSource(reload)  {
        this.mediaViewerDataSource = new OEMediaCenterMediaViewerDataSource(this.items, this.categories, this.oe);
        if(this.mediaViewerRef)    this.mediaViewerRef.setDataSource(this.mediaViewerDataSource, reload);
    }

    setMediaViewerContentIndex(index, progress)   {
        this.mediaViewerContentIndex = {index: index, applied: {animated: false, progress: progress}};
        if(this.mediaViewerRef)    this.mediaViewerRef.set(index, false, progress);
    }

    setMediaViewerContent(itemId, progress)   {
        this.setMediaViewerContentIndex(this.mediaViewerDataSource.indexForItem(itemId), progress);
    }

    updateState_(released)   {
        if(!this.oe.isReady() || released === true)   {
            this.uiVisible = false;
            this.playMode = false;
            this.directPlay = {enabled: false, trapped: false};
            this.mediaViewerVisible = false;
            this.centralView = {showAnimationControl: false, noForwardBackwardButtons: false, noStopButton: false};
            this.animationControl = {enabled: false, adapter: null};
            this.categories = [];
            this.items = [];
            this.mediaViewerDataSource = new OEMediaCenterMediaViewerDataSource();
            this.actualItemId = {item: -1, subItem: -1};
            this.actualItem = null;
            this.progress = 0;
            this.itemType = OEMediaCenterItemTypes.none;
            this.presID = -1;
            this.playEnabled = true;
            this.bottomBarConfig = {...this.props.config};
            this.setState({
                uiVisible: this.uiVisible,
                uiEnabled: false,
                enabled: false,
                playMode: this.playMode,
                directPlay: clone(this.directPlay),
                mediaViewerVisible: this.mediaViewerVisible,
                centralView: clone(this.centralView),
                animationControl: Object.assign({}, this.animationControl),
                actualItem: null,
                itemType: this.itemType,
                presID: this.presID,
                playEnabled: this.playEnabled,
                showMediaDataSource: null,
                applyingAutoplay: false,
                bottomBarConfig: clone(this.bottomBarConfig)
            });
            this.updateBlur(this.props, false, released);
            if(this.mediaViewerRef)    this.mediaViewerRef.setDataSource(this.mediaViewerDataSource);
            if(this.adapter)    {
                this.adapter.unregisterControl(this);
                if(this.adapter !== this.mediaViewerAdapter)    this.adapter.clearBinding();
                this.adapter = null;
            }
            return;
        }

        this.updateLanguage();
        this.updateUIState();
        this.updateEnabledState();
        this.updateCategories();
        this.updateItems();
        this.updateMediaViewerDataSource(true);
        this.updateActualMediaCenterItem();

        //
        this.applyAutoplay(undefined, true, false);
    }

    updateState(released)   {
        retardUpdate(this, () => {
            this.updateState_(released)
        });
    }

    // adapter callbacks
    onAnimationModeChanged(sender, mode)    {
        this.updateBlur();
    }

    onProgressChanged(sender, progress)    {}

    //
    onLanguageChanged() {
        let changes = this.mediaViewerDataSource.updateContentLocalization(this.oe);
        if(this.mediaViewerRef)    {
            for(let i = 0; i < changes.length; ++i) {
                this.mediaViewerRef.update(changes[i], false);
            }
        }
        this.updateLanguage();
    }

    onUIControllerStateChanged(message, userInfo)    {
        if(userInfo.type === this.oe.Module.UIControllerType.media_center) {
            this.updateUIState();
        }
        if(userInfo.type === this.oe.Module.UIControllerType.media_center || userInfo.type === this.oe.Module.UIControllerType.presentation)  {
            this.updateForPlayMode();
        }
    }

    onEnabledStateChanged(message, userInfo)   {
        this.updateEnabledState(userInfo.enabled);
    }

    onActualMediaCenterItemChanged(message, userInfo)    {
        this.updateActualMediaCenterItem();
    }

    onActualMediaCenterSubItemChanged(message, userInfo)    {
        this.updateActualMediaCenterSubItem();
    }

    onMediaCenterAnimationModeChanged(message, userInfo)   {
        if(this.itemType !== OEMediaCenterItemTypes.animation && this.itemType !== OEMediaCenterItemTypes.presentation) return;

        if(userInfo.mode === this.oe.Module.AnimationMode.play) {
            this.setPlayMode(true);
        } else if(userInfo.mode === this.oe.Module.AnimationMode.disabled) {
            if(!this.directPlay.enabled)    this.setPlayMode(false);
        }
    }

    onMediaCenterProgressChanged(message, userInfo)  {
        this.updateForProgress(userInfo.progress);

        if(this.mediaViewerDataSource.indexForItem(this.actualItemId) >= 0)   {
            this.mediaViewerContentIndex.applied.progress = this.progress;
            if(this.mediaViewerRef)    this.mediaViewerRef.setProgress(this.progress);
        }
    }

    onMediaCenterItemSliderConfigChanged(message, userInfo)  {
        if(this.actualItem && this.actualItemId.item === userInfo.item && this.actualItemId.subItem === userInfo.subItem)   {
            this.actualItem = Object.assign({}, this.actualItem, {sliderConfig: userInfo.config});
            this.setState({actualItem: this.actualItem});
        }
    }

    onMediaCenterShortCut(message, userInfo) {
        if(userInfo.result > 0 || userInfo.shortcut !== this.oe.Module.MediaCenterShortcutType.toggle_play) return;
        let si = this.oe.sharedInterface;

        if(this.itemType === OEMediaCenterItemTypes.video)  {
            if(this.adapter)    this.adapter.toggle();
        } else if(this.itemType === OEMediaCenterItemTypes.animation || this.itemType === OEMediaCenterItemTypes.presentation)  {

            si.getUIControllerMediaCenter().setAnimationMode(this.oe.Module.AnimationMode.pause);
            if(!this.playMode && this.itemType === OEMediaCenterItemTypes.presentation) si.getUIControllerPresentation().apply(true);

            if(!this.directPlay.enabled)   {
                this.setPlayMode(!this.playMode);
            } else {
                si.getUIControllerMediaCenter().setUIVisible(false);
            }
        }

        // note that userInfo.result <= 0 for toggle_play shortcut, i.e., no change was applied by the media center controller due to playEnabled = false
        // but we have reacted here for this shortcut and additionally there are tutor configurations awaiting a shortcut event with result 1 for toggle play
        // so we send a new shortcut event with result 1 signaling that it was reacted to the initial event 
        let userInfo_ = new this.oe.Module.Dictionary();
        si.postNotification(message, userInfo_.setMCShortcutValue('shortcut', userInfo.shortcut).setIntValue('result', 1));
        userInfo_.delete();
    }

    onActivePresentationSlideChanged(message, userInfo) {
        if(this.itemType !== OEMediaCenterItemTypes.presentation || this.presID !== userInfo.presID)    return;
        let presPlayableFlags = this.oe.sharedInterface.getUIControllerPresentation().getPresentationPlayableFlagsID(this.presID);
        if(typeof(presPlayableFlags) !== 'number')  presPlayableFlags = this.props.config.presPlayableFlags;
        if(!(presPlayableFlags & OEPresentationPlayableFlags.animatableSlideAttribute))    return;
        this.updateControls();
    }

    onPresentationDataChanged(message, userInfo)    {
        if(this.itemType !== OEMediaCenterItemTypes.presentation || this.presID !== userInfo.presID)    return;
        let changeFlags = this.oe.Module.PresentationDataChangeFlags.playable.value | this.oe.Module.PresentationDataChangeFlags.flags.value;
        if(!(userInfo.changeFlags & changeFlags))    return;
        this.updateControls();
    }

    onPresentationAnimatableStateChanged(message, userInfo) {
        if(this.itemType !== OEMediaCenterItemTypes.presentation || this.presID !== userInfo.presID)    return;
        this.updateControls();
    }

    onPresentationSlideAttributesChanged(message, userInfo) {
        if(this.itemType !== OEMediaCenterItemTypes.presentation || this.presID !== userInfo.presID)   return;

        let presController = this.oe.sharedInterface.getUIControllerPresentation();
        if(userInfo.slideID != presController.getActivePresentationSlideID(this.presID))    return;

        let presPlayableFlags = presController.getPresentationPlayableFlagsID(this.presID);
        if(typeof(presPlayableFlags) !== 'number')  presPlayableFlags = this.props.config.presPlayableFlags;
        if(!(presPlayableFlags & OEPresentationPlayableFlags.animatableSlideAttribute))    return;

        this.updateControls();
    }

    //
    onBottomBarModeLayoutTypeChanged(sender, layoutType)  {
        if(this.bottomBarModeLayoutType === layoutType) return;
        this.bottomBarModeLayoutType = layoutType;
        this.setState({bottomBarModeLayoutType: this.bottomBarModeLayoutType});
        if(this.props.config.mode === OEMediaCenterMode.bottomBar)  this.updateEdgeOffsets(false);
    }

    onRightBarSizeChanged(size)  {
        if(OEToolbox.shallowEqual(this.rightBarSize, size)) return;
        this.rightBarSize = size;
        retardUpdate(this, () => {
            this.updateLayout();
        });
    }

    onRightBarEdgeOffsetsChanged()  {
        this.updateEdgeOffsets();
    }

    onBottomBarEdgeOffsetsChanged() {
        this.updateEdgeOffsets();
    }

    onRightBarRef(ref)  {
        if(this.rightBarRef === ref)  return;
        this.rightBarRef = ref;
        this.updateEdgeOffsets(false);
    }

    onMediaViewerRef(ref)   {
        if(this.mediaViewerRef === ref) return;

        this.mediaViewerRef = ref;
        if(this.mediaViewerRef)    {
            this.mediaViewerRef.setDataSource(this.mediaViewerDataSource);

            let ci = this.mediaViewerContentIndex;
            this.mediaViewerRef.set(ci.index, ci.applied.animated, ci.applied.progress);
        }

        this.mediaViewerAdapter.setBinding(ref);
    }

    onBottomBarRef(ref) {
        if(this.bottomBarRef === ref)  return;
        this.bottomBarRef = ref;
        this.updateEdgeOffsets(false);
    }

    renderBigButtonControl()    {
        let enabled = this.state.uiEnabled && this.state.enabled;
        let show = this.state.uiVisible && this.state.centralView.showAnimationControl && !this.state.playMode && !this.state.applyingAutoplay;

        let style = {
            top:            this.state.maxEdgeOffsets.top,
            right:          this.state.maxEdgeOffsets.right,
            bottom:         0, //this.state.maxEdgeOffsets.bottom,  // bottom changes does not look good, hence we try to disable is and center with respect of the complete screen height
            left:           this.state.maxEdgeOffsets.left,
            transition:     OEAnimateHelper.transitionForInsets(this.state.maxEdgeOffsets.animate)
        };

        style.transition = style.transition + (style.transition ? ', ' : '') + 'opacity 0.333s ease';

        return (
            <div className={'central-view-inner ' + (show ? 'show' : 'hide')} style={style}>
                <OEAnimationControl
                    className="big-play-btn"
                    enabled={enabled && this.state.animationControl.enabled}
                    slider={{visible: false, enabled: false}}
                    control={{stopBtnVisible: false}}
                    iconCodes={{play: OEIconCodes.play, pause: OEIconCodes.play}}
                    adapter={this.state.animationControl.adapter}
                    onPlayBtnPressed={this.onPlayModeAnimationControlPlay}
                />
            </div>
        );
    }

    renderPlayModeControls()    {
        let enabled = this.state.uiEnabled && this.state.enabled;
        let show = this.state.uiVisible && this.state.centralView.showAnimationControl && this.state.playMode && !this.state.userHidePlayModeControls && !this.state.applyingAutoplay && !this.state.hidePlayModeControls;  // big play button xor play mode controls

        let style = {
            transition: 'opacity 0.333s ease',
        };

        return (
            <OEMediaCenterPlayModeControls
                className={show ? 'show' : 'hide'}
                style={style}
                moduleId={this.props.moduleId}
                enabled={enabled && this.state.animationControl.enabled}
                onlyPreviewSlides={this.controlOnlyPreviewSlides}
                wrap={this.wrap}
                adapter={this.state.animationControl.adapter}
                onPlayBtnPressed={this.onPlayModeAnimationControlPlay}
                onPauseBtnPressed={this.onPlayModeAnimationControlPause}
                onStopBtnPressed={this.onPlayModeAnimationControlStop}
                onBackwardBtnPressed={this.onPlayModeAnimationControlBackward}
                onForwardBtnPressed={this.onPlayModeAnimationControlForward}
                stopBtnVisible={!this.state.centralView.noStopButton}
                playBtnVisible={this.state.playEnabled}
                doNotDisableStopBtn={true}
                noForwardBackwardButtons={this.state.centralView.noForwardBackwardButtons}
            />
        );
    }

    render() {
        const config = this.props.config;
        const enabled = this.state.uiEnabled && this.state.enabled;

        const edgeOffsetsTransition = OEAnimateHelper.transitionForInsets(this.state.edgeOffsets.animate);

        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>

                <ElementEventListenerAdapter
                    element="body"
                    events={[{name: ['mousemove', 'mouseenter', 'mousedown', 'mouseup', 'click', 'touchstart', 'touchmove', 'touchend'], fn: this.onResetHidePlayModeControlsCycleEvent}]}
                />

                <OEVHLayouter onLayoutTypeChanged={this.onBottomBarModeLayoutTypeChanged}/>

                <div 
                    className={'media-center ' + this.props.className + ' std-label-text-color'}
                    style={{
                        left:           this.props.insets.left,
                        right:          this.props.insets.right,
                        bottom:         this.props.insets.bottom,
                        transition:     OEAnimateHelper.transitionForInsets(this.props.insets.animate)
                    }}
                >
                    
                    <OEMediaCenterRightBar
                        moduleId={this.props.moduleId}
                        appComponent={this.props.appComponent}
                        config={config}
                        visible={this.state.uiVisible}
                        enabled={enabled}
                        playMode={this.state.playMode}
                        directPlay={this.state.directPlay}
                        edgeOffsets={this.state.rightBar.edgeOffsets}
                        bottomBarModeLayoutType={this.state.bottomBarModeLayoutType}
                        onItemCollectionSelected={this.onItemCollectionSelected}
                        onSizeChanged={this.onRightBarSizeChanged}
                        onEdgeOffsetsChanged={this.onRightBarEdgeOffsetsChanged}
                        ref={this.onRightBarRef}
                    />

                    <div
                        className="central-view"
                        style={{top: this.state.edgeOffsets.top, right: this.state.edgeOffsets.right, bottom: this.state.edgeOffsets.bottom, left: this.state.edgeOffsets.left,
                                transition: edgeOffsetsTransition}}
                    >

                        <VelocityTransitionGroup enter={{animation: 'fadeIn', duration: 333, easing: 'ease-in-out'}} leave={{animation: 'fadeOut', duration: 333, easing: 'ease-in-out'}}>
                            {!(this.state.uiVisible && this.state.mediaViewerVisible) ? null :
                            <OEMediaViewerController
                                showControlsWhenWindow={false}
                                showNextPrevButtons={false}
                                onMediaItemChanged={this.onMediaItemChanged}
                                onProgressChanged={this.onMediaViewerProgressChanged}
                                shouldChangePrev={this.shouldChangePrev}
                                shouldChangeNext={this.shouldChangeNext}
                                onGoToItem={this.onGoToItem}
                                onShowMedia={this.onShowMedia}
                                ref={this.onMediaViewerRef}
                            />}
                        </VelocityTransitionGroup>

                        <OEModal
                            className="fullscreen-modal"
                            isOpen={Boolean(this.state.uiVisible && this.state.showMediaDataSource)}
                            noHeader={true}
                            hasCloseBtn={false}
                        >
                            <OEMediaViewerController
                                className="show-media-media-viewer"
                                dataSource={this.state.showMediaDataSource}
                                showCloseBtn={true}
                                showControlsWhenWindow={true}
                                controlsContentAlignedWhenWindowed={false}
                                showNextPrevButtons={false}
                                onCloseBtnPressed={this.onCloseBtnPressed}
                            />
                        </OEModal>

                    </div>

                    <div className="central-view central-view-outer big-play-btn">
                        {this.renderBigButtonControl()}
                    </div>

                    <div
                        className="central-view"
                        style={{top: this.state.edgeOffsets.top, right: 0, bottom: this.state.edgeOffsets.bottom, left: this.state.edgeOffsets.left,
                                transition: edgeOffsetsTransition}}
                    >   
                        {this.renderPlayModeControls()}
                    </div>

                    <OEMediaCenterBottomBar
                        moduleId={this.props.moduleId}
                        config={this.state.bottomBarConfig}
                        onlyPreviewSlides={this.showOnlyPreviewSlides}
                        visible={this.state.uiVisible}
                        enabled={enabled}
                        playEnabled={this.state.playEnabled}
                        animationControlEnabled={this.state.animationControl.enabled}
                        playMode={this.state.playMode}
                        blurring={this.state.blurring}
                        item={this.state.actualItem}
                        progress={this.state.progress}
                        adapter={this.state.animationControl.adapter}
                        edgeOffsets={this.state.bottomBar.edgeOffsets}
                        bottomBarModeLayoutType={this.state.bottomBarModeLayoutType}
                        onItemCollectionSelected={this.onItemCollectionSelected}
                        onProgressSliderChanged={this.onProgressSliderChanged}
                        onAnimationControlPlay={this.onAnimationControlPlay}
                        onAnimationControlPause={this.onAnimationControlPause}
                        onAnimationControlStop={this.onAnimationControlStop}
                        onEdgeOffsetsChanged={this.onBottomBarEdgeOffsetsChanged}
                        onMaxEdgeOffsetsChanged={this.onBottomBarEdgeOffsetsChanged}
                        ref={this.onBottomBarRef}
                    />
                    
                </div>
            </React.Fragment>
        );
    }

    onResetHidePlayModeControlsCycleEvent(event)    {
        this.resetHidePlayModeControlsCycle();
    }

    onItemCollectionSelected(index, id, subId)  {
        if(!this.oe.isReady()) return;
        let item = this.findItem({item: id, subItem: subId});
        if(!item) return;
        this.postNotificationWithItemInfo(this.oe.NotificationName.uiInstanceMediaCenterItemSelected, {item: id, subItem: subId}, item);
    }

    onProgressSliderChanged(sender, progress)   {
        this.updateForProgress(progress);
        if(!this.oe.isReady()) return;
        this.oe.sharedInterface.getUIControllerMediaCenter().setProgress(progress, false, this.actualItemId.item, this.actualItemId.subItem);
        this.postNotificationWithItemInfo(this.oe.NotificationName.uiInstanceMediaCenterProgressSliderChanged);
    }

    postNotificationWithItemInfo(name, itemId_, item_, userInfo_)  {
        if(!this.oe.isReady()) return;
        let itemId = itemId_ || this.actualItemId;
        let item = item_ || this.actualItem;
        let userInfo = userInfo_ || new this.oe.Module.Dictionary();
        userInfo.setIntValue('item', itemId.item ? itemId.item : -1);
        userInfo.setIntValue('subItem', itemId.subItem ? itemId.subItem : -1);
        userInfo.setIntValue('type', item ? (typeof(item.type) === 'object' ? item.type.value : item.type) : OEMediaCenterItemTypes.dummy);
        userInfo.setIntValue('index', item ? item.index : -1);

        let hasAudio = false;
        if(item && item.type === this.oe.Module.MediaCenterItemType.presentation) {
            hasAudio = this.oe.sharedInterface.getUIControllerPresentation().hasAudioTrackID(item.index);
        }

        userInfo.setIntValue('hasAudio', hasAudio);

        this.oe.sharedInterface.postNotification(name, userInfo);
        userInfo.delete();
    }

    onAnimationControlPlay(sender, adapter)    {
        this.postNotificationWithItemInfo(this.oe.NotificationName.uiInstanceMediaCenterPlayBtnPressed);
        if(this.itemType !== OEMediaCenterItemTypes.animation && this.itemType !== OEMediaCenterItemTypes.presentation)   return;
        
        let ret = false;

        if(!this.playEnabled)    {
            if(adapter) adapter.pause();
            if(this.itemType === OEMediaCenterItemTypes.presentation)   this.oe.sharedInterface.getUIControllerPresentation().apply(true);
            ret = true;
        }

        this.setPlayMode(true);
        this.resetHidePlayModeControlsCycle();
        return ret;
    }

    onAnimationControlPause()   {
        this.postNotificationWithItemInfo(this.oe.NotificationName.uiInstanceMediaCenterPauseBtnPressed);
        this.resetHidePlayModeControlsCycle();
    }

    onAnimationControlStop()    {
        this.postNotificationWithItemInfo(this.oe.NotificationName.uiInstanceMediaCenterStopBtnPressed);
        this.resetHidePlayModeControlsCycle();
    }

    onPlayModeAnimationControlPlay(sender, adapter)    {
        return this.onAnimationControlPlay(sender, adapter);
    }

    onPlayModeAnimationControlPause()   {
        this.onAnimationControlPause();
    }

    onPlayModeAnimationControlStop(sender, adapter)    {
        if(adapter) adapter.pause();

        if(!this.directPlay.enabled)    {
            this.setPlayMode(false);
        } else {
            if(this.oe.isReady())    this.oe.sharedInterface.getUIControllerMediaCenter().setUIVisible(false);
        }

        this.onAnimationControlStop();
        return true;
    }

    onPlayModeAnimationControlBackward()  {
        if(!this.oe.isReady()) return;
        let controller = this.oe.sharedInterface.getUIControllerPresentation();
        controller.gotoPrevSlide(this.controlOnlyPreviewSlides, this.wrap, true);
        this.postNotificationWithItemInfo(this.oe.NotificationName.uiInstanceMediaCenterPlayModeBackwardBtnPressed);
        this.resetHidePlayModeControlsCycle();
    }

    onPlayModeAnimationControlForward()  {
        if(!this.oe.isReady()) return;
        let controller = this.oe.sharedInterface.getUIControllerPresentation();
        controller.gotoNextSlide(this.controlOnlyPreviewSlides, this.wrap, true);
        this.postNotificationWithItemInfo(this.oe.NotificationName.uiInstanceMediaCenterPlayModeForwardBtnPressed);
        this.resetHidePlayModeControlsCycle();
    }

    // media viewer
    onMediaItemChanged(index)   {
        this.mediaViewerContentIndex.index = index;
        if(!this.oe.isReady()) return;
        let item = this.mediaViewerDataSource.mediaViewerContentForIndex(index);
        if(!item) return;
        this.oe.sharedInterface.getUIControllerMediaCenter().setActualMediaItemSubItemID(item.itemId.item, item.itemId.subItem);
    }

    onMediaViewerProgressChanged(progress) {
        if(!(this.state.mediaViewerVisible && this.state.uiVisible)) return;
        this.mediaViewerContentIndex.applied.progress = progress;
        this.updateForProgress(progress);
        if(!this.oe.isReady()) return;
        this.oe.sharedInterface.getUIControllerMediaCenter().setProgress(progress, true, this.actualItemId.item, this.actualItemId.subItem);
    }

    shouldChangePrev(index) {
        let item = this.mediaViewerDataSource.mediaViewerContentForIndex(index);
        return !item ? false : !item.blockPrev;
    }

    shouldChangeNext(index) {
        let item = this.mediaViewerDataSource.mediaViewerContentForIndex(index);
        return !item ? false : !item.blockNext;
    }

    onGoToItem(name)    {
        this.oe.sharedInterface.getUIControllerMediaCenter().setActualMediaItem(name);
    }

    onShowMedia(path)   {
        let resourcePath = 'app/oe/' + this.oe.Module.filePackagePathURL;

        let content = new OEMediaViewerContent(
            OEMediaViewerContentType.image,
            resourcePath + path,
            false,
            null,
            null,
            {mode: OEMediaViewerContentSizeMode.fill}
        ); 

        this.setState({showMediaDataSource: new OEMediaViewerDataSourceIntrinsic(content)});
    }

    onCloseBtnPressed() {
        this.setState({showMediaDataSource: null});
    }
}

OEMediaCenter.defaultProps = {
    className:                  '',
    moduleId:                   '',
    config:                     OEMediaCenterConfigFactory.std(),
    insets:                     {left: 0, bottom: 0, right: 0},
    devFeatures:                false
};

OEMediaCenter.propTypes = {
    className:                  PropTypes.string,
    moduleId:                   PropTypes.string,
    config:                     OEMediaCenterPropTypes.configDecl,
    insets:                     OEAnimateHelper.offsetDecl,
    devFeatures:                PropTypes.bool,
    onEdgeOffsetsChanged:       PropTypes.func,
    onBottomBarEdgeOffsetsChanged:  PropTypes.func
};

export default connectAppEnv((env) => { 
    const ui = env.config.module.uiLayerConfig;
    const ret = {
        appComponent:           env.component,
        config:                 OEDefaultConfigFactory.combineShowHelpState(ui.mediaCenter, ui.widgetConfig.showHelp, ui.manualView.links, OEManualViewLinks.mediaCenter),
        devFeatures:            env.config.module.flags && env.config.module.flags.includes(AppFlags.import)
    };
    return ret;
})(withUILevel(OEMediaCenter));